module.exports = __webpack_public_path__ + "img/BackupOutlined.160db7c1.svg";